export const iconFontAwesomeWeatherTemperatureArrowDown = (
	<i className="fa-solid fa-temperature-arrow-down"></i>
);
